/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_TitleInputs */

const en_lg_search_title = /** @type {(inputs: Lg_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the conversation you need`)
};

const id_lg_search_title = /** @type {(inputs: Lg_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan percakapan yang relevan`)
};

/**
* | output |
* | --- |
* | "Find the conversation you need" |
*
* @param {Lg_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_title = /** @type {((inputs?: Lg_Search_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_title(inputs)
	return en_lg_search_title(inputs)
});